import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 dtwin-geo",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "px-2"
  }, [_vm.dtwinHistoryZones.length ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinIsInsideZones')))])]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinIsInsideZonesText'))
    }
  }), _vm._l(_vm.dtwinHistoryZones, function (twin, i) {
    return _c('ul', {
      key: `twin_zone_${i}`
    }, [_c('li', [_c('a', {
      attrs: {
        "href": `/#/digitaltwin-mgmt/${twin.id}`,
        "target": "_blank"
      }
    }, [_vm._v("\n                  » " + _vm._s(twin.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(twin.id) + ")\n                ")])])]);
  })], 2)], 1)], 1)], 1) : _vm._e(), _vm.showMap && _vm.hideFields.indexOf('history') < 0 ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n      " + _vm._s(`${_vm.$i18n_t('DigitalTwin.DigitalTwin.map.mode')}:`) + "\n       \n      "), _c(VBtnToggle, {
    attrs: {
      "rounded": "",
      "mandatory": "",
      "color": _vm.color
    }
  }, [_c(VBtn, {
    on: {
      "click": function ($event) {
        _vm.mapMode = 'default';
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.modeDefault')) + "\n        ")]), _c(VBtn, {
    on: {
      "click": function ($event) {
        _vm.mapMode = 'history';
        _vm.mapHistoryFetch();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.modeHistory')) + "\n        ")])], 1)], 1) : _vm._e(), _vm.mapMode === 'default' ? [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-address-picker', {
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "addressObject": _vm.addressObject,
      "coordinateLookup": _vm.addressPickerCoordinateLookup,
      "mapView": false
    },
    on: {
      "address-selected": _vm.addressSelected,
      "address-clear": _vm.addressClear
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1200px"
    },
    model: {
      value: _vm.fullScreenMap,
      callback: function ($$v) {
        _vm.fullScreenMap = $$v;
      },
      expression: "fullScreenMap"
    }
  }, [_vm.showMap ? _c('core-maps', {
    attrs: {
      "markerDraggable": _vm.twinCanBeEdited,
      "geoCoordinates": _vm.dtwinCoordinates,
      "geoPolygon": _vm.dtwinPolygon,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "allowScrollZoom": !_vm.isMobile,
      "disablePolygonDrawing": _vm.hideFields.indexOf('polygon') >= 0,
      "fullScreen": ""
    },
    on: {
      "polygonUpdated": _vm.dtwinGeopolygonUpdated,
      "markerUpdated": _vm.dtwinCoordinateUpdated,
      "close-expanded": function ($event) {
        _vm.fullScreenMap = false;
      }
    }
  }) : _vm._e()], 1), _vm.showMap ? _c('core-maps', {
    attrs: {
      "markerDraggable": _vm.twinCanBeEdited,
      "geoCoordinates": _vm.dtwinCoordinates,
      "geoPolygon": _vm.dtwinPolygon,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "disablePolygonDrawing": _vm.hideFields.indexOf('polygon') >= 0
    },
    on: {
      "polygonUpdated": _vm.dtwinGeopolygonUpdated,
      "markerUpdated": _vm.dtwinCoordinateUpdated,
      "expand": function ($event) {
        _vm.fullScreenMap = true;
      }
    }
  }) : _vm._e()], 1), _vm.showMap && _vm.hideFields.indexOf('polygon') < 0 ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.twinCanBeEdited && _vm.twinObject.data.polygonMode === 'auto' ? [_c(VSlider, {
    staticClass: "mt-2 mb-4",
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.autoPolygonRadius'),
      "hint": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.autoPolygonRadiusThumb'),
      "color": _vm.color,
      "persistent-hint": "",
      "inverse-label": "",
      "min": "1",
      "max": "10",
      "thumb-size": "24",
      "thumb-label": "always"
    },
    scopedSlots: _vm._u([{
      key: "thumb-label",
      fn: function () {
        return [_vm._v("\n              " + _vm._s(`${_vm.twinObject.data.polygonRadius}`) + "\n            ")];
      },
      proxy: true
    }], null, false, 3574612106),
    model: {
      value: _vm.twinObject.data.polygonRadius,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data, "polygonRadius", $$v);
      },
      expression: "twinObject.data.polygonRadius"
    }
  })] : _vm._e(), _c(VTextarea, {
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.geoPolygon'),
      "hide-details": ""
    },
    on: {
      "change": _vm.dtwinGeoPolygonEdited
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_vm.twinObject.data.polygonMode === 'manual' ? _c(VBtn, {
          class: `my-0 v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.dtwinGeoPolygonEdited('[]');
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "dark": "",
            "small": ""
          }
        }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 3890136980),
    model: {
      value: _vm.geoPolygonJsonString,
      callback: function ($$v) {
        _vm.geoPolygonJsonString = $$v;
      },
      expression: "geoPolygonJsonString"
    }
  })], 2) : _vm._e(), _vm.showMap && _vm.hideFields.indexOf('mapicon') < 0 ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.twinImages.length > 0 ? _c(VSelect, {
    attrs: {
      "items": _vm.twinImages,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.icon'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-value": "id",
      "item-text": "name",
      "hide-details": ""
    },
    model: {
      value: _vm.twinObject.data.mapIconAttachmentId,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data, "mapIconAttachmentId", $$v);
      },
      expression: "twinObject.data.mapIconAttachmentId"
    }
  }) : _c('p', {
    staticClass: "card-description"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.iconNoAttachments')))])], 1) : _vm._e()] : [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('core-date-time-picker', {
    staticClass: "mt-0",
    attrs: {
      "from": _vm.mapHistoryQueryStartDate / 1000,
      "to": _vm.mapHistoryQueryEndDate / 1000,
      "isRange": ""
    },
    on: {
      "date:picked": _vm.mapHistoryRangePicked
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VDataFooter, {
    attrs: {
      "items-per-page-options": _vm.geoHistoryPaginationProps.itemsPerPageOptions,
      "options": _vm.geoHistoryPaginationOptions,
      "pagination": _vm.geoHistoryPaginationProps.pagination
    },
    on: {
      "update:options": function ($event) {
        _vm.geoHistoryPaginationOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "page-text",
      fn: function (props) {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.historyPerPageText')) + " " + _vm._s(props.pageStart) + " -\n            " + _vm._s(props.pageStop) + "\n            " + _vm._s(_vm.$i18n_t('Common.of')) + "\n            " + _vm._s(props.itemsLength) + "\n          ")];
      }
    }])
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1200px"
    },
    model: {
      value: _vm.fullScreenMap,
      callback: function ($$v) {
        _vm.fullScreenMap = $$v;
      },
      expression: "fullScreenMap"
    }
  }, [_vm.showMap ? _c('core-maps', {
    attrs: {
      "markerDraggable": false,
      "showPolygonControls": false,
      "geoCoordinates": _vm.dtwinCoordinates,
      "geoHistory": _vm.mapHistoryCoordinates,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "allowScrollZoom": !_vm.isMobile,
      "fullScreen": ""
    }
  }) : _vm._e()], 1), _vm.showMap ? _c('core-maps', {
    attrs: {
      "markerDraggable": false,
      "showPolygonControls": false,
      "geoCoordinates": _vm.dtwinCoordinates,
      "geoHistory": _vm.mapHistoryCoordinates,
      "overlayInfo": _vm.dtwinOverlayInfo
    },
    on: {
      "expand": function ($event) {
        _vm.fullScreenMap = true;
      }
    }
  }) : _vm._e()], 1)], _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.hideFields.indexOf('floor') < 0 || _vm.isFloorTwin && _vm.hideFields.indexOf('floorplan') < 0 ? _c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.indoorSettings')))])]), _c(VExpansionPanelContent, [_c(VRow, [_vm.isFloorTwin ? [_vm.hideFields.indexOf('floor') < 0 ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.twinCanBeEdited,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorLabel'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.twinObject.data.indoor.number,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.indoor, "number", $$v);
      },
      expression: "twinObject.data.indoor.number"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorFieldText')) + "\n                  ")])], 1) : _vm._e(), _vm.hideFields.indexOf('floorplan') < 0 ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_vm.twinImages.length > 0 ? _c(VSelect, {
    attrs: {
      "items": _vm.twinImages,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayImage'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-value": "id",
      "item-text": "name",
      "hide-details": ""
    },
    on: {
      "change": _vm.overlayImageSelected
    },
    model: {
      value: _vm.twinObject.data.indoor.overlayImageId,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.indoor, "overlayImageId", $$v);
      },
      expression: "twinObject.data.indoor.overlayImageId"
    }
  }) : _c('p', {
    staticClass: "card-description danger--text"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.attachmentEmptyState')) + "\n                  ")]), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayImageText')) + "\n                  ")]), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.button'),
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.overlayDialog = true;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-wand-magic")]), _vm._v("\n                      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.button')) + "\n                  ")], 1), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1300px"
    },
    model: {
      value: _vm.overlayDialog,
      callback: function ($$v) {
        _vm.overlayDialog = $$v;
      },
      expression: "overlayDialog"
    }
  }, [_vm.overlayDialog ? _c('core-dtwin-map-overlay-wizard-container', {
    attrs: {
      "addressObject": _vm.addressObject,
      "twinImages": _vm.twinImages
    },
    on: {
      "processed": _vm.handleOverlayImage,
      "close": function ($event) {
        _vm.overlayDialog = false;
      }
    }
  }) : _vm._e(), _vm.overlayUploadItem ? _c('core-dtwin-attachments-item', {
    key: _vm.overlayUploadItem.id || _vm.overlayUploadItem.storagePath,
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "item": _vm.overlayUploadItem,
      "source": "digitaltwin"
    },
    on: {
      "item:update": _vm.overlayImageUploaded
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm.hideFields.indexOf('floorplan') < 0 && _vm.twinObject.data.indoor.overlayImageId ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VRow, {
    staticClass: "pb-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c(VCol, {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.neLat'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.twinObject.data.indoor.neLat,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.indoor, "neLat", _vm._n($$v));
      },
      expression: "twinObject.data.indoor.neLat"
    }
  })], 1), _c(VCol, {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.neLon'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.twinObject.data.indoor.neLon,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.indoor, "neLon", _vm._n($$v));
      },
      expression: "twinObject.data.indoor.neLon"
    }
  })], 1)], 1), _c(VRow, {
    staticClass: "pt-1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c(VCol, {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.swLat'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.twinObject.data.indoor.swLat,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.indoor, "swLat", _vm._n($$v));
      },
      expression: "twinObject.data.indoor.swLat"
    }
  })], 1), _c(VCol, {
    staticClass: "px-1",
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.swLon'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.twinObject.data.indoor.swLon,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.indoor, "swLon", _vm._n($$v));
      },
      expression: "twinObject.data.indoor.swLon"
    }
  })], 1)], 1), _c('p', {
    staticClass: "card-description mt-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayBoundsText'))
    }
  })], 1) : _vm._e()] : [_vm.hasFloorTwinReadPermissions && _vm.hideFields.indexOf('floor') < 0 ? _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "objectFilter": _vm.floorTwinFilter,
      "label": `${_vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor')} ${_vm.$i18n_t('Common.digitalTwins.searchLabel')}`,
      "placeholder": `${_vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor')} ${_vm.$i18n_t('Common.digitalTwins.searchLabel')}`,
      "tenantId": _vm.twinObject.tenantId,
      "loadFullDtwinData": "",
      "hideDetails": "auto",
      "sameTenant": ""
    },
    model: {
      value: _vm.twinObject.floorDtwinId,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject, "floorDtwinId", $$v);
      },
      expression: "twinObject.floorDtwinId"
    }
  }), _c('p', {
    staticClass: "card-description mt-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorDescription'))
    }
  })], 1) : _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorTwinNoPermission')) + "\n                  ")])])]], 2)], 1)], 1)], 1) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };